import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "input"]
  static values = { rating: Number }

  connect() {
    this.updateStars()
  }

  ratingValueChanged() {
    this.updateStars()
  }

  selectRating(event) {
    const rating = parseInt(event.currentTarget.dataset.ratingValue)
    this.ratingValue = rating
    this.inputTarget.value = rating
    this.updateStars()
  }

  hoverRating(event) {
    const rating = parseInt(event.currentTarget.dataset.ratingValue)
    this.highlightStars(rating)
  }

  resetHover() {
    this.updateStars()
  }

  updateStars() {
    this.highlightStars(this.ratingValue)
  }

  highlightStars(rating) {
    this.starTargets.forEach((star, index) => {
      const starRating = index + 1
      if (starRating <= rating) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-yellow-400")
      } else {
        star.classList.remove("text-yellow-400")
        star.classList.add("text-gray-300")
      }
    })
  }
}